import { toNumber } from "lodash";
import { number } from "yup/lib/locale";
import { SERVER_URL } from "./config";

const groupNames = ["group-1", "group-2"];

const defaultGroupInfo = {
  "group-1": [
    {
      label: "Name",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "name",
      type: "text",
      placeHolder: "1234",
      url: SERVER_URL + "/consignor/",
      apiConfigKey: "getTransporterSuggestions",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "consignor_id",
      suggestionKeyword: "consignor_name",
      apiCallRequiredOnGetValue: true,
      suggestionKeywordExtra: "consignor_gst",
      suggestionSchema: {
        acknowledgement: "acknowledgement",
        address: "address",
        bilty_charge: "bilty_charge",
        city: "city",
        commission_rate: "commission_rate",
        contact_person: "contact_person",
        created_by: "created_by",
        created_date: "created_date",
        cst_no: "cst_no",
        delivery_address: "delivery_address",
        door_delivery_charge: "door_delivery_charge",
        email: "email",
        group_id: "group_id",
        group_name:"group_name",
        subgroup_name:"subgroup_name",
        collection_charge: "collection_charge",
        is_door_delivery: "is_door_delivery",
        collection_charge_unit: "collection_charge_unit",
        hamali_charge: "hamali_charge",
        limit_amt: "limit_amt",
        mobile: "mobile",
        modified_by: "modified_by",
        modified_date: "modified_date",
        pan_no: "pan_no",
        phone_office: "phone_office",
        phone_residence: "phone_residence",
        pincode: "pincode",
        suffix: "suffix",
        tin_no: "tin_no",
        transporter_gst: "gst",
        transporter_id: "id",
        transporter_name: "transporter_name",
        branch_info: "branch_info",
        subgroup_id:"subgroup_id",
        is_active:"is_active",
        automatic_billing: "automatic_billing",
        only_pod_bill: "only_pod_bill",
        company_info: "company_info",
        secondary_email: "secondary_email",
        is_account_related: "is_account_related",
        is_daily_mail: "is_daily_mail",
        is_transporter: "is_transporter",
        bill_name: "bill_name",
        bill_gst: "bill_gst",
        auto_pod_statement: "auto_pod_statement",
      },
      idClearanceNeeded: "branch_id",
      backendOnClickName: "vehicle_no",
      keyboardNavigationMap: {
        Enter: "gst",
      },
    },
    {
      label: "GST",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "gst",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "pan_no",
      toValidate: false,
      regExpValidation:
         "^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$",
       keyboardNavigationMap: {
         Enter: "bill_name",
      },
    },
    // {
    //   label: "Group Name",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "group_name",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/consignor/",
    //   apiConfigKey: "getTransporterSuggestions",
    //   suggestionKeywordForFetchApiArgs: "name",
    //   suggestionChooseQueryKeyword: "consignor_id",
    //   suggestionKeyword: "consignor_name",
    //   apiCallRequiredOnGetValue: true,
    //   toValidate: true,
    //   suggestionSchema: {
    //     name: "group_name",
    //     id: "group_id",
    //   },
    //   idClearanceNeeded: "group_id",
    //   backendOnClickName: "license_validity",
    //   keyboardNavigationMap: {
    //     Enter: "address",
    //   },
    // },
    {
      label: "Bill Name Print",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "bill_name",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "owner_name",
      keyboardNavigationMap: {
        Enter: "bill_gst",
      },
    },
    {
      label: "Bill GST Print",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "bill_gst",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "owner_name",
      keyboardNavigationMap: {
        Enter: "address",
      },
    },
    {
      label: "Address",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "address",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "owner_name",
      keyboardNavigationMap: {
        Enter: "is_active",
      },
    },
    {
      label: "Is Active",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "is_active",
      type: "dropdown",
      dropdown_items: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "is_account_related",
      },
    },
    {
        label: "Is Account Related",
        className: "form-row",
        labelClassName: "form-label-w",
        inputClassName: "form-input",
        name: "is_account_related",
        type: "dropdown",
        dropdown_items: [
          { value: "", label: "Choose" },
          { value: "1", label: "Yes" },
          { value: "0", label: "No" },
        ],
        placeHolder: "",
        keyboardNavigationMap: {
          Enter: "is_daily_mail",
        },
      },
      {
        label: "Is Daily Mail",
        className: "form-row",
        labelClassName: "form-label-w",
        inputClassName: "form-input",
        name: "is_daily_mail",
        type: "dropdown",
        dropdown_items: [
          { value: "", label: "Choose" },
          { value: "1", label: "Yes" },
          { value: "0", label: "No" },
        ],
        placeHolder: "",
        keyboardNavigationMap: {
          Enter: "is_transporter",
        },
      },
      {
        label: "Is Transporter",
        className: "form-row",
        labelClassName: "form-label-w",
        inputClassName: "form-input",
        name: "is_transporter",
        type: "dropdown",
        dropdown_items: [
          { value: "", label: "Choose" },
          { value: "1", label: "Yes" },
          { value: "0", label: "No" },
        ],
        placeHolder: "",
        keyboardNavigationMap: {
          Enter: "auto_pod_statement",
        },
      },
      {
        label: "Auto POD Statement",
        className: "form-row",
        labelClassName: "form-label-w",
        inputClassName: "form-input",
        name: "auto_pod_statement",
        type: "dropdown",
        dropdown_items: [
          { value: "", label: "Choose" },
          { value: "1", label: "Yes" },
          { value: "0", label: "No" },
        ],
        placeHolder: "",
        keyboardNavigationMap: {
          Enter: "contact_person",
        },
      },
    {
      label: "Contact Person",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "contact_person",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "owner_address",
      keyboardNavigationMap: {
        Enter: "suffix",
      },
    },
    {
      label: "Suffix",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "suffix",
      type: "text",
      placeHolder: "1234",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "body_type",
      keyboardNavigationMap: {
        Enter: "commission_rate",
      },
    },
    // {
    //   label: "Bilty Charge",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "bilty_charge",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "bilty_charge",
    //   keyboardNavigationMap: {
    //     Enter: "hamali_charge",
    //   },
    // },
    // {
    //   label: "Hamali Charge",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "hamali_charge",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "chasis_no",
    //   keyboardNavigationMap: {
    //     Enter: "is_door_delivery",
    //   },
    // },
    // {
    //   label: "Is Door Delivey",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "is_door_delivery",
    //   type: "dropdown",
    //   dropdown_items: [
    //     { value: "0", label: "No" },
    //     { value: "1", label: "Yes" },
    //   ],
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "door_delivery_charge",
    //   },
    // },
    // {
    //   label: "Door Del. Charge",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "door_delivery_charge",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "permit_no",
    //   keyboardNavigationMap: {
    //     Enter: "collection_charge_unit",
    //   },
    // },
    // {
    //   label: "Collection Charge Unit(W/C/B)",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "collection_charge_unit",
    //   type: "dropdown",
    //   dropdown_items: [
    //     { value: "W", label: "WEIGHT" },
    //     { value: "C", label: "CARTON" },
    //     { value: "B", label: "BILTY" },
    //   ],
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "collection_charge",
    //   },
    // },
    // {
    //   label: "Collection Charge",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "collection_charge",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "permit_no",
    //   keyboardNavigationMap: {
    //     Enter: "commission_rate",
    //   },
    // },
    {
      label: "Commission Rate",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "commission_rate",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "permit_validity",
      keyboardNavigationMap: {
        Enter: "acknowledgement",
      },
    },
    {
      label: "Acknowledgement",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "acknowledgement",
      type: "dropdown",
      dropdown_items: [
        { value: "0", label: "No" },
        { value: "1", label: "Yes" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "city",
      },
    },
    {
      label: "City",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "city",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "policy_no",
      keyboardNavigationMap: {
        Enter: "pincode",
      },
    },
    {
      label: "Pincode",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "pincode",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "insurance_validity",
      keyboardNavigationMap: {
        Enter: "delivery_address",
      },
    },
    {
      label: "Delivery Address",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "delivery_address",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "driver_name",
      keyboardNavigationMap: {
        Enter: "phone_office",
      },
    },
    {
      label: "Phone Office",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "phone_office",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "driver_address",
      keyboardNavigationMap: {
        Enter: "phone_residence",
      },
    },
    {
      label: "Phone Residence",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "phone_residence",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_no",
      keyboardNavigationMap: {
        Enter: "mobile",
      },
    },
    {
      label: "Mobile",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "mobile",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_validity",
      keyboardNavigationMap: {
        Enter: "email",
      },
    },
    {
      label: "Email",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "email",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_validity",
      keyboardNavigationMap: {
        Enter: "secondary_email",
      },
    },
    {
        label: "Secondary Email",
        className: "form-row",
        labelClassName: "form-label-w",
        inputClassName: "form-input",
        name: "secondary_email",
        type: "text",
        placeHolder: "",
        backendOnClickName: "license_validity",
        keyboardNavigationMap: {
          Enter: "tin_no",
        },
      },
  ],
  "group-2": [
    // {
    //   label: "City",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "city",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "policy_no",
    //   keyboardNavigationMap: {
    //     Enter: "pincode",
    //   },
    // },
    // {
    //   label: "Pincode",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "pincode",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "insurance_validity",
    //   keyboardNavigationMap: {
    //     Enter: "delivery_address",
    //   },
    // },
    // {
    //   label: "Delivery Address",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "delivery_address",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "driver_name",
    //   keyboardNavigationMap: {
    //     Enter: "phone_office",
    //   },
    // },
    // {
    //   label: "Phone Office",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "phone_office",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "driver_address",
    //   keyboardNavigationMap: {
    //     Enter: "phone_residence",
    //   },
    // },
    // {
    //   label: "Phone Residence",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "phone_residence",
    //   type: "text",
    //   placeHolder: "",
    //   backendOnClickName: "license_no",
    //   keyboardNavigationMap: {
    //     Enter: "mobile",
    //   },
    // },
    // {
    //   label: "Mobile",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "mobile",
    //   type: "text",
    //   placeHolder: "",
    //   backendOnClickName: "license_validity",
    //   keyboardNavigationMap: {
    //     Enter: "email",
    //   },
    // },
    // {
    //   label: "Email",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "email",
    //   type: "text",
    //   placeHolder: "",
    //   backendOnClickName: "license_validity",
    //   keyboardNavigationMap: {
    //     Enter: "tin_no",
    //   },
    // },
    {
      label: "Tin No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "tin_no",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_validity",
      keyboardNavigationMap: {
        Enter: "cst_no",
      },
    },
    {
      label: "Cst No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "cst_no",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_validity",
      keyboardNavigationMap: {
        Enter: "pan_no",
      },
    },
    {
      label: "Pan No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "pan_no",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_validity",
      keyboardNavigationMap: {
        Enter: "limit_amt",
      },
    },
    {
      label: "Limit Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "limit_amt",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_validity",
      keyboardNavigationMap: {
        Enter: "group_name",
      },
    },
    {
      label: "Sub Group",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "subgroup_name",
      type: "text",
      placeHolder: "1234",
      url: SERVER_URL + "/subgroup/filter/",
      apiConfigKey: "getSubGroupSuggestions",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "id",
      suggestionKeyword: "name",
      apiCallRequiredOnGetValue: true,
      toValidate: true,
      // regExpValidation: "[a-zA-z]",
      suggestionSchema: {
        id: "subgroup_id",
        name: "subgroup_name",
        group_name:"group_name",
        group_id:"group_id",
      },
      suggestionKeywordExtra: "consignor_gst",
      idClearanceNeeded: "id",
      backendOnClickName: "subgroup_id",
      keyboardNavigationMap: {
        Enter: "automatic_billing",
      },
    },
    {
      label: "Group",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "group_name",
      type: "text",
      placeHolder: "1234",
      url: SERVER_URL + "/group/filter/",
      apiConfigKey: "getGroupSuggestions",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "id",
      suggestionKeyword: "name",
      suggestionSchema: {
        id: "group_id",
        name: "group_name",
      },
      apiCallRequiredOnGetValue: true,
      suggestionKeywordExtra: "consignor_gst",
      idClearanceNeeded: "group_id",
      backendOnClickName: "vehicle_no",
      keyboardNavigationMap: {
        Enter: "subgroup_name",
      },
    },

    {
      label: "Automatic Billing",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "automatic_billing",
      type: "dropdown",
      dropdown_items: [
        { value: "0", label: "No" },
        { value: "1", label: "Yes" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "only_pod_bill",
      },
    },
    {
      label: "Only POD Billing",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "only_pod_bill",
      type: "dropdown",
      dropdown_items: [
        { value: "0", label: "No" },
        { value: "1", label: "Yes" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "consignor_name",
      },
    },
  ],
  "group-3": [
    { key: 1, branch_name: "Ahmedabad" },
    { key: 2, branch_name: "Narol" },
    { key: 3, branch_name: "Sarkhej" },
    { key: 4, branch_name: "Bhavnagar" },
    { key: 5, branch_name: "Mehsana" },
    { key: 6, branch_name: "Junagadh" },
    { key: 7, branch_name: "Aslali" },
    { key: 8, branch_name: "Bardoli" },
    { key: 9, branch_name: "Rajkot" },
    { key: 10, branch_name: "Morbi" },
    { key: 11, branch_name: "Ankleshwar" },
    { key: 12, branch_name: "Bilimora" },
    { key: 13, branch_name: "Kamrej" },
    { key: 14, branch_name: "Himmatnagar" },
    { key: 15, branch_name: "Palanpur" },
    { key: 16, branch_name: "Vadodara" },
    { key: 17, branch_name: "Patan" },
    { key: 18, branch_name: "Dasrath" },
    { key: 19, branch_name: "Gandhidham" },
    { key: 20, branch_name: "Surat" },
    { key: 21, branch_name: "Vapi" },
    { key: 22, branch_name: "Navsari" },
    { key: 23, branch_name: "Anand" },
    { key: 24, branch_name: "Bharuch" },
    { key: 25, branch_name: "Nadiad" },
    { key: 26, branch_name: "Unjha" },
    { key: 39, branch_name: "Bhuj" },
    { key: 28, branch_name: "Valsad" },
    { key: 29, branch_name: "Gondal" },
    { key: 30, branch_name: "Deesa" },
    { key: 31, branch_name: "Surendranagar" },
    { key: 32, branch_name: "Bhivandi" },
    { key: 33, branch_name: "Jamnagar" },
    { key: 34, branch_name: "Navagam" },
    { key: 168, branch_name: "Daman" },
    { key: 579, branch_name: "Silvasa" },
    { key: 628, branch_name: "Umergaon" },
  ],
};

const jainamGroupInfo = {
  "group-1": [
    {
      label: "Name",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "name",
      type: "text",
      placeHolder: "1234",
      url: SERVER_URL + "/consignor/",
      apiConfigKey: "getTransporterSuggestions",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "consignor_id",
      suggestionKeyword: "consignor_name",
      apiCallRequiredOnGetValue: true,
      suggestionKeywordExtra: "consignor_gst",
      suggestionSchema: {
        acknowledgement: "acknowledgement",
        address: "address",
        bilty_charge: "bilty_charge",
        city: "city",
        commission_rate: "commission_rate",
        contact_person: "contact_person",
        created_by: "created_by",
        created_date: "created_date",
        cst_no: "cst_no",
        delivery_address: "delivery_address",
        door_delivery_charge: "door_delivery_charge",
        email: "email",
        group_id: "group_id",
        group_name:"group_name",
        subgroup_name:"subgroup_name",
        collection_charge: "collection_charge",
        is_door_delivery: "is_door_delivery",
        collection_charge_unit: "collection_charge_unit",
        hamali_charge: "hamali_charge",
        limit_amt: "limit_amt",
        mobile: "mobile",
        modified_by: "modified_by",
        modified_date: "modified_date",
        pan_no: "pan_no",
        phone_office: "phone_office",
        phone_residence: "phone_residence",
        pincode: "pincode",
        suffix: "suffix",
        tin_no: "tin_no",
        transporter_gst: "gst",
        transporter_id: "id",
        transporter_name: "transporter_name",
        branch_info: "branch_info",
        subgroup_id:"subgroup_id",
        is_active:"is_active",
        automatic_billing: "automatic_billing",
        only_pod_bill: "only_pod_bill",
        company_info: "company_info",
        secondary_email: "secondary_email",
        is_account_related: "is_account_related",
        is_daily_mail: "is_daily_mail",
        is_transporter: "is_transporter",
        bill_name: "bill_name",
        bill_gst: "bill_gst",
        auto_pod_statement: "auto_pod_statement",
      },
      idClearanceNeeded: "branch_id",
      backendOnClickName: "vehicle_no",
      keyboardNavigationMap: {
        Enter: "gst",
      },
    },
    {
      label: "GST",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "gst",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "pan_no",
      toValidate: false,
      regExpValidation:
        "^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$",
      keyboardNavigationMap: {
        Enter: "bill_name",
      },
    },
    // {
    //   label: "Group Name",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "group_name",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/consignor/",
    //   apiConfigKey: "getTransporterSuggestions",
    //   suggestionKeywordForFetchApiArgs: "name",
    //   suggestionChooseQueryKeyword: "consignor_id",
    //   suggestionKeyword: "consignor_name",
    //   apiCallRequiredOnGetValue: true,
    //   toValidate: true,
    //   suggestionSchema: {
    //     name: "group_name",
    //     id: "group_id",
    //   },
    //   idClearanceNeeded: "group_id",
    //   backendOnClickName: "license_validity",
    //   keyboardNavigationMap: {
    //     Enter: "address",
    //   },
    // },
    {
      label: "Bill Name Print",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "bill_name",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "owner_name",
      keyboardNavigationMap: {
        Enter: "bill_gst",
      },
    },
    {
      label: "Bill GST Print",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "bill_gst",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "owner_name",
      keyboardNavigationMap: {
        Enter: "address",
      },
    },
    {
      label: "Address",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "address",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "owner_name",
      keyboardNavigationMap: {
        Enter: "is_active",
      },
    },
    {
      label: "Is Active",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "is_active",
      type: "dropdown",
      dropdown_items: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "is_account_related",
      },
    },
    {
        label: "Is Account Related",
        className: "form-row",
        labelClassName: "form-label-w",
        inputClassName: "form-input",
        name: "is_account_related",
        type: "dropdown",
        dropdown_items: [
          { value: "", label: "Choose" },
          { value: "1", label: "Yes" },
          { value: "0", label: "No" },
        ],
        placeHolder: "",
        keyboardNavigationMap: {
          Enter: "is_transporter",
        },
      },
      // {
      //   label: "Is Daily Mail",
      //   className: "form-row",
      //   labelClassName: "form-label-w",
      //   inputClassName: "form-input",
      //   name: "is_daily_mail",
      //   type: "dropdown",
      //   dropdown_items: [
      //     { value: "", label: "Choose" },
      //     { value: "1", label: "Yes" },
      //     { value: "0", label: "No" },
      //   ],
      //   placeHolder: "",
      //   keyboardNavigationMap: {
      //     Enter: "is_transporter",
      //   },
      // },
      {
        label: "Is Transporter",
        className: "form-row",
        labelClassName: "form-label-w",
        inputClassName: "form-input",
        name: "is_transporter",
        type: "dropdown",
        dropdown_items: [
          { value: "", label: "Choose" },
          { value: "1", label: "Yes" },
          { value: "0", label: "No" },
        ],
        placeHolder: "",
        keyboardNavigationMap: {
          Enter: "auto_pod_statement",
        },
      },
      {
        label: "Auto POD Statement",
        className: "form-row",
        labelClassName: "form-label-w",
        inputClassName: "form-input",
        name: "auto_pod_statement",
        type: "dropdown",
        dropdown_items: [
          { value: "", label: "Choose" },
          { value: "1", label: "Yes" },
          { value: "0", label: "No" },
        ],
        placeHolder: "",
        keyboardNavigationMap: {
          Enter: "contact_person",
        },
      },
    {
      label: "Contact Person",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "contact_person",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "owner_address",
      keyboardNavigationMap: {
        Enter: "suffix",
      },
    },
    {
      label: "Suffix",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "suffix",
      type: "text",
      placeHolder: "1234",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "body_type",
      keyboardNavigationMap: {
        Enter: "acknowledgement",
      },
    },
    // {
    //   label: "Bilty Charge",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "bilty_charge",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "bilty_charge",
    //   keyboardNavigationMap: {
    //     Enter: "hamali_charge",
    //   },
    // },
    // {
    //   label: "Hamali Charge",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "hamali_charge",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "chasis_no",
    //   keyboardNavigationMap: {
    //     Enter: "is_door_delivery",
    //   },
    // },
    // {
    //   label: "Is Door Delivey",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "is_door_delivery",
    //   type: "dropdown",
    //   dropdown_items: [
    //     { value: "0", label: "No" },
    //     { value: "1", label: "Yes" },
    //   ],
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "door_delivery_charge",
    //   },
    // },
    // {
    //   label: "Door Del. Charge",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "door_delivery_charge",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "permit_no",
    //   keyboardNavigationMap: {
    //     Enter: "collection_charge_unit",
    //   },
    // },
    // {
    //   label: "Collection Charge Unit(W/C/B)",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "collection_charge_unit",
    //   type: "dropdown",
    //   dropdown_items: [
    //     { value: "W", label: "WEIGHT" },
    //     { value: "C", label: "CARTON" },
    //     { value: "B", label: "BILTY" },
    //   ],
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "collection_charge",
    //   },
    // },
    // {
    //   label: "Collection Charge",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "collection_charge",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "permit_no",
    //   keyboardNavigationMap: {
    //     Enter: "commission_rate",
    //   },
    // },
    // {
    //   label: "Commission Rate",
    //   className: "form-row",
    //   labelClassName: "form-label-w",
    //   inputClassName: "form-input",
    //   name: "commission_rate",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "permit_validity",
    //   keyboardNavigationMap: {
    //     Enter: "acknowledgement",
    //   },
    // },
    {
      label: "Acknowledgement",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "acknowledgement",
      type: "dropdown",
      dropdown_items: [
        { value: "0", label: "No" },
        { value: "1", label: "Yes" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "city",
      },
    },
    {
      label: "City",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "city",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "policy_no",
      keyboardNavigationMap: {
        Enter: "pincode",
      },
    },
    {
      label: "Pincode",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "pincode",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "insurance_validity",
      keyboardNavigationMap: {
        Enter: "delivery_address",
      },
    },
    {
      label: "Delivery Address",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "delivery_address",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "driver_name",
      keyboardNavigationMap: {
        Enter: "phone_office",
      },
    },
    {
      label: "Phone Office",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "phone_office",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "driver_address",
      keyboardNavigationMap: {
        Enter: "phone_residence",
      },
    },
    {
      label: "Phone Residence",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "phone_residence",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_no",
      keyboardNavigationMap: {
        Enter: "mobile",
      },
    },
    {
      label: "Mobile",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "mobile",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_validity",
      keyboardNavigationMap: {
        Enter: "email",
      },
    },
    {
      label: "Email",
      className: "form-row",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "email",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_validity",
      keyboardNavigationMap: {
        Enter: "secondary_email",
      },
    },
    {
        label: "Secondary Email",
        className: "form-row",
        labelClassName: "form-label-w",
        inputClassName: "form-input",
        name: "secondary_email",
        type: "text",
        placeHolder: "",
        backendOnClickName: "license_validity",
        keyboardNavigationMap: {
          Enter: "tin_no",
        },
      },
  ],
  "group-2": [
    // {
    //   label: "City",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "city",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "policy_no",
    //   keyboardNavigationMap: {
    //     Enter: "pincode",
    //   },
    // },
    // {
    //   label: "Pincode",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "pincode",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "insurance_validity",
    //   keyboardNavigationMap: {
    //     Enter: "delivery_address",
    //   },
    // },
    // {
    //   label: "Delivery Address",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "delivery_address",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "driver_name",
    //   keyboardNavigationMap: {
    //     Enter: "phone_office",
    //   },
    // },
    // {
    //   label: "Phone Office",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "phone_office",
    //   type: "text",
    //   placeHolder: "",
    //   url: SERVER_URL + "/city/",
    //   suggestionKeyword: "name",
    //   backendOnClickName: "driver_address",
    //   keyboardNavigationMap: {
    //     Enter: "phone_residence",
    //   },
    // },
    // {
    //   label: "Phone Residence",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "phone_residence",
    //   type: "text",
    //   placeHolder: "",
    //   backendOnClickName: "license_no",
    //   keyboardNavigationMap: {
    //     Enter: "mobile",
    //   },
    // },
    // {
    //   label: "Mobile",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "mobile",
    //   type: "text",
    //   placeHolder: "",
    //   backendOnClickName: "license_validity",
    //   keyboardNavigationMap: {
    //     Enter: "email",
    //   },
    // },
    // {
    //   label: "Email",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "email",
    //   type: "text",
    //   placeHolder: "",
    //   backendOnClickName: "license_validity",
    //   keyboardNavigationMap: {
    //     Enter: "tin_no",
    //   },
    // },
    {
      label: "Tin No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "tin_no",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_validity",
      keyboardNavigationMap: {
        Enter: "cst_no",
      },
    },
    {
      label: "Cst No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "cst_no",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_validity",
      keyboardNavigationMap: {
        Enter: "pan_no",
      },
    },
    {
      label: "Pan No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "pan_no",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_validity",
      keyboardNavigationMap: {
        Enter: "limit_amt",
      },
    },
    {
      label: "Limit Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "limit_amt",
      type: "text",
      placeHolder: "",
      backendOnClickName: "license_validity",
      keyboardNavigationMap: {
        Enter: "group_name",
      },
    },
    {
      label: "Sub Group",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "subgroup_name",
      type: "text",
      placeHolder: "1234",
      url: SERVER_URL + "/subgroup/filter/",
      apiConfigKey: "getSubGroupSuggestions",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "id",
      suggestionKeyword: "name",
      apiCallRequiredOnGetValue: true,
      toValidate: true,
      // regExpValidation: "[a-zA-z]",
      suggestionSchema: {
        id: "subgroup_id",
        name: "subgroup_name",
        group_name:"group_name",
        group_id:"group_id",
      },
      suggestionKeywordExtra: "consignor_gst",
      idClearanceNeeded: "id",
      backendOnClickName: "subgroup_id",
      keyboardNavigationMap: {
        Enter: "automatic_billing",
      },
    },
    {
      label: "Group",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "group_name",
      type: "text",
      placeHolder: "1234",
      url: SERVER_URL + "/group/filter/",
      apiConfigKey: "getGroupSuggestions",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "id",
      suggestionKeyword: "name",
      suggestionSchema: {
        id: "group_id",
        name: "group_name",
      },
      apiCallRequiredOnGetValue: true,
      suggestionKeywordExtra: "consignor_gst",
      idClearanceNeeded: "group_id",
      backendOnClickName: "vehicle_no",
      keyboardNavigationMap: {
        Enter: "subgroup_name",
      },
    },

    {
      label: "Automatic Billing",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "automatic_billing",
      type: "dropdown",
      dropdown_items: [
        { value: "0", label: "No" },
        { value: "1", label: "Yes" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "only_pod_bill",
      },
    },
    {
      label: "Only POD Billing",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "only_pod_bill",
      type: "dropdown",
      dropdown_items: [
        { value: "0", label: "No" },
        { value: "1", label: "Yes" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "consignor_name",
      },
    },
  ],
  "group-3": [
    { key: 1, branch_name: "Ahmedabad" },
    { key: 2, branch_name: "Narol" },
    { key: 3, branch_name: "Sarkhej" },
    { key: 4, branch_name: "Bhavnagar" },
    { key: 5, branch_name: "Mehsana" },
    { key: 6, branch_name: "Junagadh" },
    { key: 7, branch_name: "Aslali" },
    { key: 8, branch_name: "Bardoli" },
    { key: 9, branch_name: "Rajkot" },
    { key: 10, branch_name: "Morbi" },
    { key: 11, branch_name: "Ankleshwar" },
    { key: 12, branch_name: "Bilimora" },
    { key: 13, branch_name: "Kamrej" },
    { key: 14, branch_name: "Himmatnagar" },
    { key: 15, branch_name: "Palanpur" },
    { key: 16, branch_name: "Vadodara" },
    { key: 17, branch_name: "Patan" },
    { key: 18, branch_name: "Dasrath" },
    { key: 19, branch_name: "Gandhidham" },
    { key: 20, branch_name: "Surat" },
    { key: 21, branch_name: "Vapi" },
    { key: 22, branch_name: "Navsari" },
    { key: 23, branch_name: "Anand" },
    { key: 24, branch_name: "Bharuch" },
    { key: 25, branch_name: "Nadiad" },
    { key: 26, branch_name: "Unjha" },
    { key: 39, branch_name: "Bhuj" },
    { key: 28, branch_name: "Valsad" },
    { key: 29, branch_name: "Gondal" },
    { key: 30, branch_name: "Deesa" },
    { key: 31, branch_name: "Surendranagar" },
    { key: 32, branch_name: "Bhivandi" },
    { key: 33, branch_name: "Jamnagar" },
    { key: 34, branch_name: "Navagam" },
    { key: 168, branch_name: "Daman" },
    { key: 579, branch_name: "Silvasa" },
    { key: 628, branch_name: "Umergaon" },
  ],
};

const getGroupInfoBasedOnClient = ()=> {
  
  if (process.env.REACT_APP_CLIENT == "jncargo"){
    return jainamGroupInfo
  } else {
    return defaultGroupInfo
  }
}

var groupInfo = getGroupInfoBasedOnClient()

const dataObject = {
  id: "",
  name: "",
  gst: "",
  address: "",
  contact_person: "",
  suffix: "",
  is_active:"1",
  collection_charge: "",
  bilty_charge: "",
  hamali_charge: "",
  door_delivery_charge: "",
  commission_rate: "",
  collection_charge_unit: "",
  acknowledgement: "",
  is_door_delivery: "",
  city: "",
  pincode: "",
  delivery_address: "",
  phone_office: "",
  phone_residence: "",
  group_id:"",
  subgroup_id:"",
  group_name:"",
  subgroup_name:"",
  mobile: "",
  email: "",
  tin_no: "",
  created_by:"",
  created_from:"",
  cst_no: "",
  pan_no: "",
  limit_amt: "",
  group_id: "",
  unique_id:"",
  voucher_id:"",
  group_name: "",
  created_by: "",
  modified_by: "",
  branch_info: [],
  only_pod_bill: "0",
  automatic_billing: "0",
  company_info: [],
  consignor_name: "",
  consignor_gst: "",
  consignor_id: "",
  to_pay_account_name: "",
  to_pay_account_id: "",
  secondary_email: "",
  is_account_related: "",
  is_daily_mail: "",
  is_transporter: "",
  bill_name: "",
  bill_gst: "",
  auto_pod_statement: "",
};

function validate(values) {
  let errors = {};

  function validator(value, regexp) {
    var regex = new RegExp(regexp);
    if (values.hasOwnProperty(value)) {
      if (!values[value].trim()) {
        errors[value] = "Required Field";
      } else if (!regex.test(values[value])) {
        errors[value] = "Validation Error";
      } else {
        errors[value] = "";
      }
    }
  }
  for (let group_name of groupNames) {
    for (let i = 0; i < groupInfo[group_name].length; i++) {
      let field_object = groupInfo[group_name][i];
      console.log(field_object.type);
      if (field_object.type == "number") {
        console.log("vaaaaal", values.bilty_charge);
      }
      if (field_object.toValidate) {
        validator(field_object.name, field_object.regExpValidation);
      }
    }
  }
  return errors;
}

const accountGroupTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Consignor Name", className: "text-center table-header" },
  { label: "Consignor GST", className: "text-center table-header" },
];

const accountGroupTableItems = [
  {
    type: "text",
    name: "name",
    label: "Consignor Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "gst",
    label: "Consignor GST",
    className: "form-control-large-col",
  },
];

export { groupInfo, dataObject, validate, accountGroupTableHeader, accountGroupTableItems };
